export default __webpack_public_path__ + "static/media/pic7.ee22e19e.jpg";